import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Grid,
  IconButton,
} from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import SendIcon from "@mui/icons-material/Send";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLocation, useNavigate } from "react-router-dom";

const DeferredDefectDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [targetSprint, setTargetSprint] = useState("");
  const [targetDate, setTargetDate] = useState("");
  const [bugID, setBugID] = useState("");
  const [summary, setSummary] = useState("");
  const [severity, setSeverity] = useState("");
  const [priority, setPriority] = useState("");
  const [reason, setReason] = useState("");
  const [stakeholderApproval, setStakeholderApproval] = useState(false);
  const [defects, setDefects] = useState([]);

  const isFormValid = () => defects.length > 0;

  const handleDeferredDefect = () => {
    if (!bugID.trim() || !summary.trim() || !severity.trim()) {
      console.log("Bug ID, Summary, and Severity are required.");
      return;
    }
    if (defects.some((defect) => defect.id === bugID)) {
      console.log("Duplicate Bug ID detected, not adding.");
      return;
    }
    setDefects([...defects, { id: bugID, summary, severity }]);
    console.log("Deferred defect added");
  };

  const handleDeferredDefectNext = () => {
    try {
      console.log("Next button clicked");
      let defectDetailsData = {
        defects: defects,
        targetSprint: targetSprint,
        targetDate: targetDate,
        stakeholderApproval: stakeholderApproval,
        reason: reason,
      };
      navigate("/dashboard/sprint-summary-report/output", {
        state: { ...location.state, defectDetailsData: defectDetailsData },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handlePullFromJIRA = (e) => {
    e.stopPropagation();
    setBugID("JIRA-1234");
    setSummary("JIRA Summary");
    setSeverity("High");
    setPriority("High");
    setReason("JIRA Reason");
    setTargetSprint("2022-12-31");
    setTargetDate("2022-12-31");
    setStakeholderApproval(true);
  };

  return (
    <CommonAccordion
      summary={
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <span>Deferred Defect Details</span>
          <Button
            variant="text"
            startIcon={<LoadIcon />}
            sx={{
              textTransform: "none",
              fontSize: "14px",
            }}
            onClick={handlePullFromJIRA}
          >
            Pull from JIRA
          </Button>
        </Box>
      }
      details={
        <Box sx={{ paddingRight: 4, paddingLeft: 1, mb: 3, mt: 2 }}>
          <Box
            sx={{
              backgroundColor: "#F0F8FF",
              padding: 4,
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Bug ID"
                  variant="outlined"
                  value={bugID}
                  onChange={(e) => setBugID(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Summary"
                  variant="outlined"
                  value={summary}
                  onChange={(e) => setSummary(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{ backgroundColor: "#F0F8FF" }}
                >
                  <InputLabel id="severity-label" shrink>
                    Severity
                  </InputLabel>
                  <Select
                    labelId="severity-label"
                    value={severity}
                    onChange={(e) => setSeverity(e.target.value)}
                    displayEmpty
                    label="Severity"
                    IconComponent={ArrowDropDownIcon}
                    sx={{
                      color: "#333",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#B0B0B0",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#757575",
                      },
                      "& .MuiSelect-icon": { color: "#4A4A4A", fontSize: 36 },
                      fontSize: 16,
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Severity
                    </MenuItem>
                    <MenuItem value="Low">Low</MenuItem>
                    <MenuItem value="Medium">Medium</MenuItem>
                    <MenuItem value="High">High</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{ backgroundColor: "#F0F8FF" }}
                >
                  <InputLabel id="priority-label" shrink>
                    Priority
                  </InputLabel>
                  <Select
                    labelId="priority-label"
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                    displayEmpty
                    label="Priority"
                    IconComponent={ArrowDropDownIcon}
                    sx={{
                      color: "#333",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#B0B0B0",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#757575",
                      },
                      "& .MuiSelect-icon": { color: "#4A4A4A", fontSize: 36 },
                      fontSize: 16,
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Priority
                    </MenuItem>
                    <MenuItem value="Low">Low</MenuItem>
                    <MenuItem value="Medium">Medium</MenuItem>
                    <MenuItem value="High">High</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={5}
                  label="Reason for Deferral"
                  placeholder="Enter Response Type"
                  variant="outlined"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Target Sprint"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={targetSprint}
                  onChange={(e) => setTargetSprint(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Target Date"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={targetDate}
                  onChange={(e) => setTargetDate(e.target.value)}
                  inputProps={{ min: targetSprint || "" }}
                  disabled={!targetSprint}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={stakeholderApproval}
                      onChange={(e) => setStakeholderApproval(e.target.checked)}
                    />
                  }
                  label="Stakeholder Approval"
                />
              </Grid>
              <Grid xs={12} sx={{ mt: 2, mr: 2, ml: 3, mb: 0 }}>
                <Button
                  variant="outlined"
                  onClick={handleDeferredDefect}
                  sx={{
                    textTransform: "none",
                    width: 188,
                    height: 36,
                    borderRadius: "8px",
                    paddingTop: "8px",
                    paddingRight: "12px",
                    paddingBottom: "8px",
                    paddingLeft: "12px",
                    borderWidth: "1px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    whiteSpace: "nowrap", // Prevents text from wrapping
                    minWidth: 0, // Ensures the button doesn't expand unnecessarily
                    color: "#49A3FF",
                    fontFamily: "Manrope",
                    fontSize: "14px",
                  }}
                >
                  <AddIcon fontSize="small" />
                  Add Deferred Defect
                </Button>
              </Grid>
            </Grid>
          </Box>

          {defects.length > 0 && (
            <TableContainer
              component={Paper}
              sx={{
                mt: 4,
                mb: 4,
                borderRadius: 2,
                border: "1px solid #E0E0E0", // Light border around the entire table
                boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow for elevation
              }}
            >
              <Table>
                <TableHead>
                  <TableRow sx={{ borderBottom: "1px solid #E0E0E0" }}>
                    <TableCell
                      sx={{
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        padding: "4px 12px",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      Bug ID
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        padding: "4px 12px",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      Summary
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        padding: "4px 12px",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      Severity
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        padding: "4px 12px",
                        borderRight: "1px solid #ddd",
                      }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {defects.map((defect, index) => (
                    <TableRow
                      key={index}
                      sx={{ borderBottom: "1px solid #E0E0E0" }}
                    >
                      {" "}
                      {/* Border between rows */}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #E0E0E0",
                          padding: "8px",
                          fontFamily: "Manrope",
                          fontSize: "14px",
                          color: "#000000",
                        }}
                      >
                        {defect.id}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #E0E0E0",
                          padding: "8px",
                          fontFamily: "Manrope",
                          fontSize: "14px",
                          color: "#000000",
                        }}
                      >
                        {defect.summary}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          borderRight: "1px solid #E0E0E0",
                          padding: "8px",
                          fontFamily: "Manrope",
                          fontSize: "14px",
                          color: "#CA0000",
                        }}
                      >
                        {defect.severity}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: "8px",
                          fontFamily: "Manrope",
                          fontSize: "14px",
                          color: "#000000",
                        }}
                      >
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() =>
                            setDefects(
                              defects.filter((d) => d.id !== defect.id)
                            )
                          }
                        >
                          <RemoveCircleOutlineIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      }
      buttons={[
        {
          label: "Next",
          variant: "contained",
          startIcon: <SendIcon />,
          onClick: handleDeferredDefectNext,

          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: isFormValid() ? "#49A3FF" : "grey",
            color: "white",
            "&:hover": {
              backgroundColor: isFormValid() ? "#007BFF" : "darkgrey",
            },
          },
          disabled: !isFormValid(),
        },
      ]}
    />
  );
};

export default DeferredDefectDetails;
